import * as React from 'react';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import styles from './conferencing-modal-wrapper.module.css';

type Props = {
    integrationName: string;
    onClick: () => void;
};

export function ConnectedWithReconfigureButton(props: Props) {
    return (
        <Card hasBorder={true} fitHeight={true}>
            <div className={styles['button-content']}>
                <StackLegacy spacing={8} isHorizontal={true}>
                    <CheckmarkIcon color={colors.green} size={17} alignCenter={true} />
                    <div>{props.integrationName} is connected</div>
                </StackLegacy>
                <Button variant='text-primary' noPadding={true} onClick={props.onClick}>
                    Reconfigure
                </Button>
            </div>
        </Card>
    );
}
